import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  paper: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  mb2: {
    marginBottom: theme.spacing(2),
  },
  ml2: {
    marginLeft: theme.spacing(2),
  },
  box: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: '18px',
  },
  dfr: {
    flexDirection: 'row',
  },
  btnSuccess: {
    backgroundColor: 'green',
    color: 'white',
  },
  redTxt: {
    color: 'red',
  },
  greenTxt: {
    color: 'green',
  },
  unlockIcon: {
    marginBottom: theme.spacing(0.5),
  },
  inlineField: {
    padding: 0,
  },
  languagePaper: {
    position: 'absolute',
    width: '25vw',
    minHeight: '28vh',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  stickToBottom: {
    bottom: theme.spacing(2),
  },
  passwordPaper: {
    position: 'absolute',
    width: '25vw',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  impersonatePaper: {
    position: 'absolute',
    width: '35vw',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
});
